import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { Loader } from "../Loader";
import styles from "./PendingMusicTrackPlaceholder.module.scss";
const Skeleton = ({ width, height, radius }) => (_jsx("span", { className: styles.skeleton, style: { width, height, borderRadius: radius } }));
/**
 * Скелетон + лоадер для трека, пока по WebSocket не придёт готовность музыки
 * (result_status: music_generated или completed).
 */
export const PendingMusicTrackPlaceholder = ({ language, className, coverWidth = 72, coverHeight = 72, title }) => {
    const asListRow = Boolean(className);
    const rootClass = [
        styles.card,
        !asListRow && styles.standalone,
        className,
    ]
        .filter(Boolean)
        .join(" ");
    const trimmedTitle = title?.trim();
    return (_jsx("div", { className: rootClass, children: _jsxs("div", { className: styles.row, children: [_jsx(Skeleton, { width: coverWidth, height: coverHeight, radius: 12 }), _jsxs("div", { className: styles.body, children: [trimmedTitle ? (_jsx("span", { className: styles.title, children: trimmedTitle })) : (_jsx(Skeleton, { width: "55%", height: 18, radius: 6 })), _jsx(Skeleton, { width: "35%", height: 14, radius: 6 }), _jsx("div", { className: styles.statusLine, children: _jsx("span", { className: styles.statusText, children: language === "ru" ? "Генерируем музыку…" : "Generating music…" }) })] }), _jsx("div", { style: { flex: "0 0 auto" }, children: _jsx(Loader, { size: "sm" }) })] }) }));
};
